<mat-expansion-panel class="pto-panel" (opened)="load()">

  <mat-expansion-panel-header>
    <mat-panel-title class="pto-title">{{ title }}</mat-panel-title>
    <mat-panel-description>
      <span *ngIf="loaded && !error" class="pto-count">
        {{ visibleEntries.length }} out
      </span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="pto-body">

    <div *ngIf="loading" class="pto-center">
      <mat-spinner diameter="28"></mat-spinner>
    </div>

    <div *ngIf="!loading && error" class="pto-error">
      <span>{{ error }}</span>
      <button mat-button color="primary" (click)="refresh()">Retry</button>
    </div>

    <ng-container *ngIf="!loading && !error && loaded">

      <div class="pto-controls" *ngIf="hasTeam || regionOptions.length > 0">
        <mat-checkbox *ngIf="hasTeam" [(ngModel)]="teamOnly">My team only</mat-checkbox>
        <!-- Native select on purpose: a mat-select overlay renders outside the
             my-alternate-theme wrapper and picks up the app's dark theme. -->
        <select *ngIf="regionOptions.length > 0"
                class="pto-region-select"
                [(ngModel)]="regionFilter"
                aria-label="Filter by region">
          <option value="">All regions</option>
          <option *ngFor="let region of regionOptions" [value]="region">{{ region }}</option>
        </select>
      </div>

      <p *ngIf="focusOutOfRange" class="pto-outofrange">
        {{ focusDate }} is outside the loaded window.
        <a (click)="loadForFocusDate()">Load time off from that date</a>
      </p>

      <p *ngIf="visibleEntries.length === 0" class="pto-empty">
        No time off scheduled in this window<span *ngIf="regionFilter"> for {{ regionFilter }}</span>.
        <a *ngIf="regionFilter" class="pto-clear-region" (click)="regionFilter = ''">Show all regions</a>
      </p>

      <table *ngIf="visibleEntries.length > 0" class="pto-table">
        <tr>
          <th>Employee</th>
          <th>Region</th>
          <th>Dates</th>
          <th>Days</th>
        </tr>
        <tr *ngFor="let entry of visibleEntries"
            [class.pto-current]="entry.is_current"
            [class.pto-focused]="isFocused(entry)">
          <td>{{ entry.employee_name }}</td>
          <td>{{ entry.region }}</td>
          <td>{{ formatRange(entry) }}</td>
          <td>{{ entry.days }}</td>
        </tr>
      </table>

      <div class="pto-footer">
        <span *ngIf="range">{{ range.start }} – {{ range.end }}</span>
        <button mat-icon-button (click)="refresh()" matTooltip="Refresh from BambooHR">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <p *ngIf="unlinked.length > 0" class="pto-unlinked" [matTooltip]="unlinkedNames">
        {{ unlinked.length }} employee(s) not linked to BambooHR — their time off cannot be shown.
      </p>

    </ng-container>

  </div>

</mat-expansion-panel>
